(function () {
	window.addEventListener('DOMContentLoaded', function () {
		const tabs = document.querySelectorAll('.tabs');
		if (!tabs.length) return;
		class Tabs {
			constructor(element) {
				this.tabs = element;
				this.buttons = element.querySelectorAll('.tabs__button');
				this.panels = element.querySelectorAll('.tabs__panel');
				this.sidebar = element.querySelector('.tabs__sidebar');
				this.sidebarMenu = element.querySelector('.tabs__menu');
				this.activePanel = null;
				this.toggleSidebarButton = document.querySelector('.tabs__sidebar-toggle');
				this.sentinel = document.querySelector('.tabs__sentinel');
				this.activeButton = null;
				this.isMobile = false;
				this.sidebarToggled = true;
				this.userToggled = false;
				this.openEvent = new Event('sidebar-open');
				this.closeEvent = new Event('sidebar-close');
				this.toggleEvent = new Event('sidebar-clicked');
				this.navigationHeight = document.querySelector('#masthead').offsetHeight;
				this.isHomePage = document.body.classList.contains('home');
			}

			static initAll() {
				const tabs = document.querySelectorAll('.tabs');
				tabs.forEach(tab => new Tabs(tab).init());
			}

			init() {
				// console.log('tabs init');
				if (!this.checkDevice()) {
					this.setInitialPanelForDesktop();
				}
				this.setInitialSidebarState();
				this.checkHash();
				this.addEventListeners();
			}

			setInitialSidebarState() {
				this.checkDevice();
				if (!this.activePanel && this.isMobile) {
					this.toggleSidebarButton.querySelector('span').textContent = 'Choose a Topic';
				}
				if (this.isMobile && !window.location.hash) {
					this.sidebarToggled = false;
				} else {
					this.sidebarToggled = true;
				}
			}

			setInitialPanelForDesktop() {
				if (!window.location.hash && !this.isMobile) {
					this.updatePanel(this.buttons[0]);
					this.updateHash(this.buttons[0]);
				}
			}

			checkDevice() {
				if (im.lessThan('tablet')) {
					this.isMobile = true;
				} else {
					this.isMobile = false;
				}
			}

			checkHash() {
				if (this.isHomePage || document.body.classList.contains('page-id-13')) {
					// console.log('home page');
					return;
				}
				const hash = window.location.hash.substring(1);
				if (!hash) return;
				const button = Array.from(this.buttons).find(button => button.dataset.target === hash);
				this.changePanel(button || this.buttons[0]);
			}

			updateHash(button) {
				if (this.isHomePage || document.body.classList.contains('page-id-13')) {
					// console.log('home page');
					return;
				}
				const target = button.dataset.target;
				window.location.hash = target;
			}

			scrollToTop() {
				if (document.body.classList.contains('home')) return;
				let navigationHeight = document.querySelector('.site-header').scrollHeight;
				if (isElementInViewport(this.activePanel) < 0) {
					console.log('out of view');
					gsap.to(window, {
						scrollTo: {
							y: this.tabs,
							offsetY: this.navigationHeight,
						},
						duration: 1,

						ease: 'power2.inOut',
					});
				}

				function isElementInViewport(element) {
					const rect = element.getBoundingClientRect();
					return rect.top;
					// return rect.top > 0;
				}
			}

			addEventListeners() {
				this.buttons.forEach(button => {
					button.addEventListener('click', () => this.changePanel(button));
				});

				window.addEventListener('hashchange', () => this.checkHash());

				this.toggleSidebarButton.addEventListener('click', () => {
					this.toggleSidebar(this.sidebarToggled);
					this.userToggled = !this.userToggled;
				});

				window.addEventListener('resize', () => {
					this.checkDevice();
					this.collapseOnResize();
					this.updateHeight();
					this.fixPanelWidthForMobile();
				});

				window.addEventListener('accordion-toggle', e => {
					if (this.activePanel) {
						const panelHeight = this.activePanel.offsetHeight;
						const newHeight = e.detail.newItem.querySelector('.accordion-item__wrapper');
						const prevHeight = e.detail.prevItem.querySelector('.accordion-item__wrapper');
						let transitionDuration = e.detail.newItem.querySelector('.accordion-item__content')
							.style.transitionDuration;
						// strip the ms from the transition duration
						transitionDuration = transitionDuration.substring(0, transitionDuration.length - 2);
						let height = newHeight.scrollHeight - prevHeight.scrollHeight;

						gsap.to(this.sentinel, { height: panelHeight + height, duration: 600 / 1000 });
					}
				});

				window.addEventListener('accordion-open', e => {
					if (this.activePanel) {
						// console.log('opening');
						const panelHeight = this.activePanel.offsetHeight;
						const accordionWrapper = e.detail.newItem.querySelector('.accordion-item__wrapper');
						let transitionDuration = e.detail.newItem.querySelector('.accordion-item__content')
							.style.transitionDuration;
						// strip the ms from the transition duration
						transitionDuration = transitionDuration.substring(0, transitionDuration.length - 2);
						gsap.to(this.sentinel, {
							height: panelHeight + accordionWrapper.scrollHeight,
							duration: 600 / 1000,
						});
					}
				});

				window.addEventListener('accordion-close', e => {
					const accordionWrapper = e.detail.item.querySelector('.accordion-item__wrapper');
					let transitionDuration = e.detail.item.querySelector('.accordion-item__content').style
						.transitionDuration;
					// strip the ms from the transition duration
					transitionDuration = transitionDuration.substring(0, transitionDuration.length - 2);
					gsap.to(this.sentinel, {
						height: this.activePanel.offsetHeight - accordionWrapper.scrollHeight,
						duration: 600 / 1000,
					});
				});
			}

			collapseOnResize() {
				if (im.lessThan('tablet') && this.sidebarToggled && !this.userToggled) {
					this.toggleSidebar(true);
				} else if (im.greaterThan('tablet') && !this.sidebarToggled && !this.userToggled) {
					this.toggleSidebar(false);
				}
			}

			updatePanel(button) {
				if (this.activeButton) this.activeButton.classList.remove('tabs__button--active');
				if (this.activePanel) this.activePanel.classList.remove('tabs__panel--active');
				const target = button.dataset.target;
				const panel = Array.from(this.panels).find(panel => panel.dataset.target === target);
				this.activeButton = button;
				this.activePanel = panel;
				button.classList.add('tabs__button--active');
				panel.classList.add('tabs__panel--active');
				// Get the height of the panel and set the sentinel to that height
				this.updateHeight();
				// setTimeout(() => {
				// 	this.updateHeight();
				// }, 350);

				setTimeout(() => {
					// Emit a resize event
					window.dispatchEvent(new Event('resize'));
				}, 500);
			}

			updateHeight() {
				if (!this.activePanel) return;
				const panelHeight = this.activePanel.offsetHeight;
				gsap.to(this.sentinel, {
					height: panelHeight,
					duration: 0.5,
				});
			}

			changePanel(button) {
				this.tabs.classList.add('tabs--active');
				if (button.classList.contains('tabs__button--active')) return;
				this.updatePanel(button);
				this.updateHash(button);
				this.scrollToTop();
				if (im.lessThan('tablet')) {
					this.toggleSidebar(true);
				}
			}

			fixPanelWidthForMobile() {
				if (this.activePanel === null) return;
				if (window.innerWidth < 900) {
					const width = this.tabs.offsetWidth;
					this.activePanel.style.width = `${width}px`;
				} else {
					// this.activePanel.style.width = 'auto';
					this.activePanel.style.width = '100%';
				}
			}

			toggleSidebar(open = true) {
				if (open) {
					// this.sidebarToggled = true;
					this.tabs.classList.add('tabs--sidebar-collapsed');
					this.toggleSidebarButton.classList.add('tabs__sidebar-toggle--active');
					this.toggleSidebarButton.querySelector('span').textContent = 'Show Menu';

					this.sidebarMenu.style.width = `${this.sidebar.offsetWidth}px`;
					this.fixPanelWidthForMobile();

					setTimeout(() => {
						this.sidebar.style.height = `${this.activePanel.scrollHeight}px`;
					}, 350);
				} else {
					// this.sidebarToggled = false;
					this.tabs.classList.remove('tabs--sidebar-collapsed');
					this.toggleSidebarButton.classList.remove('tabs__sidebar-toggle--active');
					this.toggleSidebarButton.querySelector('span').textContent = 'Collapse Menu';
					// if (!this.activePanel) {
					// 	this.toggleSidebarButton.querySelector('span').textContent = 'Choose a Topic';
					// }
					this.sidebar.style.height = 'auto';
					setTimeout(() => {
						this.sidebarMenu.style.width = `auto`;
					}, 350);
				}
				setTimeout(() => {
					this.updateHeight();
				}, 350);
				setTimeout(() => {
					// Emit a resize event
					window.dispatchEvent(new Event('resize'));
				}, 500);
				this.sidebarToggled = !open;
			}
		}

		Tabs.initAll();
	});
})();

(function () {
	// Animate the side bar menu items in

	const tabsButtons = document.querySelectorAll('.tabs__button');
	const tabsMenu = document.querySelector('.tabs__menu');
	if (tabsButtons === null || tabsMenu === null) return;
	// start: 'top 80%', -> top refers to the elemenent itself, 80% refers to the viewport
	// end: 'bottom 20%', -> bottom refers to the elemenent itself, 20% refers to the viewport

	let start = 'top 85%';
	let end = 'bottom 8%';

	// if (window.innerWidth < 900) {
	// 	start = '0 100%';
	// 	end = '50% 0%';
	// }

	gsap.from([, '.tabs__sidebar-toggle', tabsButtons], {
		// duration: 0.5,
		x: '-100%',
		autoAlpha: 0,
		stagger: {
			each: 0.034,
		},
		scrollTrigger: {
			trigger: tabsMenu,
			toggleActions: 'play restart restart reverse',
			start,
			end,
			// markers: true,
		},
	});
})();
